<template>
  <div class="core">
    <div class="layui-fluid">
      <pub-search :search-type="'add'" :tableObj="tableObj" :searchConfig="searchConfig" exportTemplate="工程师表.xlsx">
        <template>
          <button class="layui-btn" title="新增工程师" @click="addService">
            <i class="layui-icon">&#xe624;</i>
            新增工程师
          </button>
        </template>
      </pub-search>
      <layui-table
        ref="engineer"
        table-name="YW_ENGINEER"
        :beforeRender="handleBeforeRnder"
        :page-size="20"
        :page-range="6"
        :page-options="[10, 20, 50, 100]"
        :skin="'line'"
        :sort="['CREATE_TIME:DESC']"
        @table-event-edit="edit($event)"
        @table-event-check="check($event)"
        @table-event-del="$refs.engineer.delRows($event.data)"
      >
        <div>
          <div checkbox="true" align="center" fixed="left" width="60"></div>
          <!-- <div title="序号" width="60"  fixed="left" field="_NUMBER" align="center"></div> -->
          <layui-tableconfig :config = "tableList"></layui-tableconfig>
          <div rowspan="3" align="center" fixed="right" title="操作" width="130">
            <script type="text/html" v-pre>
              <a class=" layui-btn-xs" lay-event="check" style="cursor:pointer">查看</a>
              <a class=" layui-btn-xs" lay-event="edit"  style="cursor:pointer">编辑</a>
              <a class=" layui-btn-xs layui-btn-xs-danger" lay-event="del"  style="cursor:pointer">删除</a>
            </script>
          </div>
        </div>
      </layui-table>
    </div>
    <engineer-form v-if="engineerForm" :visible.sync="engineerForm" :formType="formType" :formData="formData"/>
  </div>
</template>
<script>
import "../../../utils/map/css/core.css"
import engineerForm from './engineerForm'

export default {
  name: 'engineer',
  components: {
    engineerForm
  },
  data () {
    return {
      tableList:[
        { field: 'ENGINEER_BH', title: '工程师编号',  width: 150, sort: true },
        { field: 'SERVICE_ID_DESC', title: '所属服务商',  width: 300},
        { field: 'ENGINEER_NAME', title: '工程师姓名',  width: 150},
        { field: 'ENGINEER_PHONE', title: '联系电话',  width: 150 },
        { field: 'SSD_DESC', title: '所属地' , width: 250 },
        { field: 'WORK_TIME', title: '工作时间', width: 300 },
        { field: 'SERVICE_DIRECTION_DESC', title: '服务类型', width: 160 },
      ],
      searchConfig: {
        basic: [
          { TYPE:'input', WIDTH:260, FIELD: 'ENGINEER_BH:2,ENGINEER_NAME:2,ENGINEER_PHONE:2,SSX:2,SERVICE_NAME:2', PLACEHOLDER: '请输入搜索条件'},
        ],
        advanced: [
          { TYPE:'input', NAME: '工程师编号 :', FIELD:'ENGINEER_BH:2', PLACEHOLDER: '请输入查询条件'},
          { TYPE:'input', NAME: '工程师姓名 :', FIELD:'ENGINEER_NAME:2', PLACEHOLDER: '请输入查询条件'},
          { TYPE:'input', NAME: '联系电话 :', FIELD:'ENGINEER_PHONE:2', PLACEHOLDER: '请输入查询条件'},
          { TYPE:'layui-multiselect', NAME: '服务类型:', FIELD: 'SERVICE_DIRECTION:1',textField: 'text', valueField: 'value',initData:this.dict.getData('FILTER_SERVICE_TYPE'),},
        ],
        showBatch: true
      },
      engineerForm: false,
      formType: null,
      formData: null,
      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
    }
  },
  mounted(){
    this.tableObj = this.$refs.engineer;
  },
  methods: {
    /**
     * 新增工程师
     */
    addService () {
      this.engineerForm = true;
      this.formType = 'add';
    },
    /**
     * 编辑表格
     */
    edit($event){
      this.formType = 'edit';
      this.formData = $event.data
      this.engineerForm = true;
    },
    check($event){
      this.formType = 'browser';
      this.formData = $event.data
      this.engineerForm = true;
    },
    handleBeforeRnder(data){
      if(data && data.length > 0) {
        data.forEach((e) => {
          e.SSD = (e.PROVINCE ? e.PROVINCE : '') + "," + (e.CITY ? e.CITY : '') + "," + (e.DISTRICT ? e.DISTRICT : '')
          e.SSD_DESC = (e.PROVINCE ? e.PROVINCE_DESC : '') + "" + (e.CITY ? "-" + e.CITY_DESC : '') + "" + (e.DISTRICT ? "-" + e.DISTRICT_DESC : '')
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/person/engineerManage/index.vue